"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = color;

var _colors = require("./colors");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * utility function to retrieve a desired color and optionally it's shade (if defined)
 * @param name
 * @returns color string value
 * @public
 */


function color(name) {
  return function (props) {
    var _ref = props || {},
        _ref$theme = _ref.theme;

    _ref$theme = _ref$theme === void 0 ? {} : _ref$theme;
    var themeColors = _ref$theme.colors;

    var colorPalette = _objectSpread({}, themeColors || _colors.CLASSIC_COLORS);

    var colorValue = colorPalette[name];
    var shouldThrow = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

    if (typeof colorValue !== 'string') {
      if (shouldThrow) {
        throw new Error("Color '".concat(name, "' must be defined and a string."));
      }

      return '';
    }

    return colorValue;
  };
}